/**
 * List of collection slugs that have 0 products.
 * These collections will be hidden from:
 * - Header navigation
 * - Footer links
 * - All Collections page
 * 
 * To show a collection again, simply remove it from this list.
 * The collection page itself will still work, but show the "expanding" empty state.
 */
export const EMPTY_COLLECTION_SLUGS: string[] = [
  // Commercial (subcategories that are empty)
  'undercounter-commercial-refrigerators',
  
  // Specialty (currently empty — no standalone products in catalog)
  'kimchi-refrigerators',
  'water-dispensers', // matches fridges WITH dispensers, not standalone units — misleading
  
  // NOTE: built-in-freezers REMOVED — has 88 products, was incorrectly hidden
  // NOTE: ice-makers REMOVED — has 2 products, should be shown
]

/**
 * Check if a collection slug is empty (has 0 products)
 */
export function isEmptyCollection(slug: string): boolean {
  return EMPTY_COLLECTION_SLUGS.includes(slug)
}

/**
 * Filter out empty collections from an array of items with href or slug properties
 */
export function filterEmptyCollections<T extends { href?: string; slug?: string }>(items: T[]): T[] {
  return items.filter(item => {
    // Extract slug from href (e.g., "/collections/refrigerators" -> "refrigerators")
    const slug = item.slug || (item.href?.replace('/collections/', '') ?? '')
    return !isEmptyCollection(slug)
  })
}

